























































































































































































import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";
import {
  RpasApi,
  CustomersApi,
  LocationsApi,
  UnitsApi,
  VariablesApi,
  TreatmentDatabasesApi,
} from "../../../apis";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { AxiosResponse } from "axios";
import ConfirmDialog from "../../components/user-management/ConfirmDialog.vue";
import {
  IRule,
  PHASE,
  INIT_DATA_TEMPLATE,
  IDataTemplate,
} from "./index";
import RuleTemplate from "./RuleTemplate.vue";
import RulePharse from "./RulePharse.vue";

enum ACTION {
  NEW = "ADD",
  EDIT = "EDIT",
  VIEW = "VIEW",
}

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    ConfirmDialog,
    RulePharse,
    RuleTemplate,
  },
})
export default class RPAForm extends Vue {
  selectedID: string;

  get isNewMode() {
    return this.currentMode === ACTION.NEW;
  }

  get isEditMode() {
    return this.currentMode === ACTION.EDIT;
  }

  get isViewMode() {
    return this.currentMode === ACTION.VIEW;
  }

  get currentMode(): ACTION {
    return this.$route.meta.mode as ACTION;
  }

  set currentMode(mode: ACTION) {
    this.currentMode = mode;
  }

  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;
  panel = [0];
  PHARE_1 = PHASE.PHASE_1;
  PHARE_2 = PHASE.PHASE_2;
  PHARE_3 = PHASE.PHASE_3;
  PHARE_4 = PHASE.PHASE_4;
  PHASE_OTHER = PHASE.PHASE_OTHER;

  rpaName = null;
  customerId = null;
  locationId = null;
  unitId = null;
  ruleListPhareOne: Array<IRule> = [];
  ruleListPhareTwo: Array<IRule> = [];
  ruleListPhareThree: Array<IRule> = [];
  ruleListPhareFour: Array<IRule> = [];
  ruleListPhareOther: Array<IRule> = [];

  customerOptions = [];
  locationOptions = [];
  unitOptions = [];
  variableOptions = [];
  packageOptions = [];

  created() {
    if (this.$route.query.copyID) {
      this.loadCopyRPA(this.$route.query.copyID as string);
    } else if (this.isEditMode || this.isViewMode) {
      this.selectedID = this.$route.params.id;
    }
    this.panel = [0, 1, 2, 3];
    this.initForm();
  }

  async loadCopyRPA(copyID: string) {
    this.$util.showLoading();
    try {
      const rpaRes = await new RpasApi().getRPA({ id: copyID });
      const rpaData = rpaRes.data.data[0];
      // Xóa _id trong các rule của từng phase
      const cleanRules = (rules) =>
        rules.map(rule => {
          const newRule = { ...rule };
          delete newRule._id;
          delete newRule.id;
          delete newRule.variable;
          delete newRule.package;
          delete newRule.variableId;
          delete newRule.otherVariableId;
          delete newRule.otherVariable;
          return newRule;
        });
      this.rpaName = rpaData.rpaName + ' (Copy)';
      this.customerId = null;
      this.locationId = null;
      this.unitId =null;
      this.ruleListPhareOne = this.createRuleByPhase(cleanRules(rpaData.phaseOne), this.PHARE_1);
      this.ruleListPhareTwo = this.createRuleByPhase(cleanRules(rpaData.phaseTwo), this.PHARE_2);
      this.ruleListPhareThree = this.createRuleByPhase(cleanRules(rpaData.phaseThree), this.PHARE_3);
      this.ruleListPhareFour = this.createRuleByPhase(cleanRules(rpaData.phaseFour), this.PHARE_4);
    } catch (e) {
      console.error("Error loading copy RPA data:", e);
      this.$util.showError('Copy RPA data is invalid!');
    } finally {
      this.$util.hideLoading();
    }
  }

  async initForm() {
    let customersRes;
    let packageRes;
    try {
      this.$util.showLoading();
      [customersRes, packageRes] = await Promise.all([
        this.getActiveCustomer(),
        this.getPackages(),
      ]);
    } catch (error) {
      this.$util.showError(error);
      return;
    } finally {
      this.$util.hideLoading();
    }

    //builder dropdown
    this.customerOptions = customersRes.data.data;
    this.packageOptions = packageRes.data.data.map((packageItem) => {
      return {
        value: packageItem.id,
        text: packageItem.package,
      };
    });

    //check mode
    if ((this.isEditMode || this.isViewMode) && this.selectedID) {
      // get by id;
      this.onGetRPAById();
    } else {
      // new mode
    }
  }

  async onGetRPAById() {
    try {
      this.$util.showLoading();
      const rpaRes = await new RpasApi().getRPA({
        id: this.selectedID,
      });
      const rpaData = rpaRes.data.data[0];
      this.rpaName = rpaData.rpaName;
      this.locationId = rpaData.location.id;
      this.customerId = rpaData.customer.id;
      this.unitId = rpaData.unit.id;
      Promise.all([
        this.onChangeCustomer(),
        this.onChangeLocation(),
        this.onChangeUnit(),
      ]);
      // setTimeout(() => {
        this.ruleListPhareOne = this.createRuleByPhase(rpaData.phaseOne, this.PHARE_1);
        this.ruleListPhareTwo = this.createRuleByPhase(rpaData.phaseTwo, this.PHARE_2);
        this.ruleListPhareThree = this.createRuleByPhase(rpaData.phaseThree, this.PHARE_3);
        this.ruleListPhareFour = this.createRuleByPhase(rpaData.phaseFour, this.PHARE_4);
      // }, 1000);
    } catch (error) {
      this.$util.showError(error);
      return;
    } finally {
      this.$util.hideLoading();
      // fill input and selected dropdơn
    }
  }

  createRuleByPhase(rules, phase: PHASE): IRule[] {
    const sorted = (rules || []).slice().sort((a, b) => {
      const aOrder = (a && typeof a.orderNo === 'number') ? a.orderNo : null;
      const bOrder = (b && typeof b.orderNo === 'number') ? b.orderNo : null;
      if (aOrder === null && bOrder === null) return 0;
      if (aOrder === null) return 1;
      if (bOrder === null) return -1;
      return aOrder - bOrder;
    });
    return sorted.map((dataTemplate, index) => {
      const orderNo = (dataTemplate.orderNo !== undefined && dataTemplate.orderNo !== null)
        ? dataTemplate.orderNo
        : index;
      return {
        ruleKey: index,
        phase: phase,
        rpaTemplate: dataTemplate.template,
        dataTemplate: {
          ...this.createdDataTemplate(dataTemplate),
          orderNo: orderNo
        }
      };
    });
  }

  createdDataTemplate(rpaData): IDataTemplate {
    return {
      ...INIT_DATA_TEMPLATE,
      ...rpaData,
      packageId: rpaData.package ? rpaData.package.id : undefined,
      variableId: rpaData.variable ? rpaData.variable.id : undefined,
      otherVariableId: !rpaData.otherVariable ? "" : rpaData.otherVariable.id,
      valueTemplate1: rpaData.template === 1 ? rpaData.value : null,
      valueTemplate2: rpaData.template === 2 ? rpaData.value : null,
      valueTemplate3: rpaData.template === 3 ? rpaData.value : null,
    };
  }

  async getActiveCustomer(): Promise<AxiosResponse> {
    return await new CustomersApi().getAllCustomerByStringAndStatus({
      keyword: "",
      status: "Active",
    });
  }

  async getPackages(): Promise<AxiosResponse> {
    return await new TreatmentDatabasesApi().getPackageInTreatmentDataBase();
  }

  async onChangeCustomer(reset: boolean = false) {
    if (reset) {
      this.locationOptions = [];
      this.locationId = "";
      this.unitOptions = [];
      this.unitId = "";
    }
    if (!this.customerId) return;
    try {
      this.$util.showLoading();
      const res = await new CustomersApi().getActiveLocationsByCustomerId({
        id: this.customerId,
      });
      this.locationOptions = res.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onChangeLocation(reset: boolean = false) {
    if (reset) {
      this.unitOptions = [];
      this.unitId = "";
    }
    if (!this.locationId) return;
    try {
      this.$util.showLoading();
      const res = await new UnitsApi().getUnitByLocationId({
        locationId: this.locationId,
      });
      this.unitOptions = res.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onChangeUnit(reset: boolean = false) {
    if (reset) {
      for (const rule of this.ruleListPhareOne) {
        if (rule.dataTemplate) {
          rule.dataTemplate.variableId = "";
          rule.dataTemplate.otherVariableId = "";
        }
      }
      for (const rule of this.ruleListPhareTwo) {
        if (rule.dataTemplate) {
          rule.dataTemplate.variableId = "";
          rule.dataTemplate.otherVariableId = "";
        }
      }
      for (const rule of this.ruleListPhareThree) {
        if (rule.dataTemplate) {
          rule.dataTemplate.variableId = "";
          rule.dataTemplate.otherVariableId = "";
        }
      }
      for (const rule of this.ruleListPhareFour) {
        if (rule.dataTemplate) {
          rule.dataTemplate.variableId = "";
          rule.dataTemplate.otherVariableId = "";
        }
      }
    }
    try {
      this.$util.showLoading();
      const variablesRes = await new VariablesApi().getVariablesByUnitId({
        id: this.unitId,
      });
      this.variableOptions = variablesRes.data.data.map((variable) => {
        return {
          value: variable.id,
          text: `${variable.variableName} - ${variable.memory} - ${variable.controller}`,
          type: variable.type,
        };
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  get saveClick() {
    return this.$store.getters.saveRPAClick;
  }

  @Watch("saveClick")
  onSaveClick() {
    this.onSubmit();
  }

  async onSubmit() {
    const isValid = await this.observer.validate();
    if (!isValid) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    this.$util.showLoading();
    await this.doSubmit()
      .then((res) => this.handleSuccess())
      .catch((err) => this.handleFailed(err));
    this.$util.hideLoading();
  }

  async doSubmit(): Promise<AxiosResponse> {
    const getRPARuleRequest = (ruleListPhare) =>
      ruleListPhare.map((rule, idx) => {
        const orderNo = rule.dataTemplate && rule.dataTemplate.orderNo != null ? rule.dataTemplate.orderNo : idx;
        const { orderNo: _ignore = null, ...rest } = rule.dataTemplate || {};
        return {
          ...rest,
          value: rule.dataTemplate[`valueTemplate${rule.dataTemplate.template}`],
          orderNo
        };
      });

    const body = {
      rpaName: this.rpaName,
      customerId: this.customerId,
      locationId: this.locationId,
      unitId: this.unitId,
      phaseOne: getRPARuleRequest(this.ruleListPhareOne),
      phaseTwo: getRPARuleRequest(this.ruleListPhareTwo),
      phaseThree: getRPARuleRequest(this.ruleListPhareThree),
      phaseFour: getRPARuleRequest(this.ruleListPhareFour),
    };
    if (this.isEditMode) {
      return new RpasApi().editRPA({
        id: this.selectedID,
        putRPARequest: body
      });
    }
    return new RpasApi().postRPA({
      postRPARequest: body,
    });
  }

  handleSuccess() {
    this.getRouteCancel();
  }

  getRouteCancel() {
    this.$router.push({ name: "rpa" });
  }

  handleFailed(err) {
    this.$util.showError(err);
  }

}
